// src/TrkTracking/trk-tracking.ts
function getTrk() {
  const params = new URLSearchParams(window.location.search);
  return params.get("trk");
}
function appendTrk(url) {
  if (!url) {
    return void 0;
  }
  const trk = getTrk();
  if (!trk) {
    return url;
  }
  const fragmentIndex = url.indexOf("#");
  const urlWithoutFragment = fragmentIndex === -1 ? url : url.slice(0, fragmentIndex);
  const fragment = fragmentIndex === -1 ? "" : url.slice(fragmentIndex);
  const queryIndex = urlWithoutFragment.indexOf("?");
  const queryString = queryIndex === -1 ? "" : urlWithoutFragment.slice(queryIndex);
  const existingParams = new URLSearchParams(queryString);
  if (existingParams.has("trk")) {
    return url;
  }
  const encodedTrk = encodeURIComponent(trk);
  const separator = queryIndex === -1 ? "?" : "&";
  return `${urlWithoutFragment}${separator}trk=${encodedTrk}${fragment}`;
}
function buildNavigateUrl(baseUrl, hashPath) {
  const trk = getTrk();
  const normalizedHashPath = hashPath || "/";
  if (!trk) {
    return `${baseUrl}#${normalizedHashPath}`;
  }
  const encodedTrk = encodeURIComponent(trk);
  const queryIndex = baseUrl.indexOf("?");
  const separator = queryIndex === -1 ? "?" : "&";
  return `${baseUrl}${separator}trk=${encodedTrk}#${normalizedHashPath}`;
}
export {
  appendTrk,
  buildNavigateUrl,
  getTrk
};
//# sourceMappingURL=index.js.map
